import { getEligibleVariantName } from 'helpers/experimentV2';
import { State } from 'store/types';

export interface DynamicParams {
  [key: string]: string;
}

const getDynamicAlgoParams = (
  state: State,
  experimentID: string
): DynamicParams => {
  if (!state || !experimentID) {
    return {};
  }
  const variant = getEligibleVariantName(state, experimentID);
  /* eslint-disable no-unsafe-optional-chaining */
  const { apiQueryParamConfig } = state.remoteConfig?.configs;
  let params = {};
  if (variant && apiQueryParamConfig[variant]) {
    params = {
      ...apiQueryParamConfig[variant],
    };
  }
  return params;
};

export default getDynamicAlgoParams;
